import React from "react";
import { jsx } from "slate-hyperscript";
import Styles from "../Editor.module.scss";
import {
    BlockHandler, ElementType,
} from "./base";

BlockHandler.register(ElementType.BLOCKQUOTE, {
    nodeTypes: ["BLOCKQUOTE"],
    toBlock: child => <blockquote className={`text-gray-600 ${Styles.blockquote}`}>{child}</blockquote>,
    serialize: child => `<blockquote>${child}</blockquote>`,
    deserialize: children => jsx("element", { type: ElementType.BLOCKQUOTE }, children),
});
